<div class="add-endpoints" [formGroup]="addEndpointsFormGroup">
  <app-popup-top-line></app-popup-top-line>
  <div class="add-endpoints-header">
    <div class="title">
      {{ 'policyPage.config.endpointFilteringContent.addEndpoint' | labelsProvider }}
    </div>
    <img class="close-button" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="add-endpoints-body" formArrayName="endpointsToAdd">
    <div class="add-endpoints-body-description">
      {{ 'policyPage.config.endpointFilteringContent.addEndpointsDescription' | labelsProvider }}
    </div>

    <div *ngFor="let control of endpointsToAdd.controls; let i = index" [formGroupName]="i">
      <div
        class="input"
        [ngClass]="{
          'input-invalid': control.touched && control.invalid,
          'input-valid': control.touched && control.valid,
        }"
      >
        <input
          type="text"
          formControlName="url"
          placeholder="{{ 'policyPage.config.endpointFilteringContent.enterEndpoint' | labelsProvider }}"
        />
        <img
          class="add-endpoints-body-cancel"
          *ngIf="i > 0"
          src="assets/images/common/cancel.svg"
          (click)="removeEndpoint(i)"
        />
      </div>
      <div>
        <div class="error-message" *ngIf="control.touched && control.invalid && control.value['url']">
          {{ 'policyPage.config.endpointFilteringContent.invalidEndpoint' | labelsProvider }}
        </div>
      </div>
    </div>

    <div class="error-message" *ngIf="endpointsToAdd.touched && endpointsToAdd.invalid && endpointsToAdd.errors">
      {{ 'policyPage.config.endpointFilteringContent.enterUniqueEndpointsMsg' | labelsProvider }}
    </div>
    <div class="add-more" (click)="addMoreClicked()" *ngIf="endpointsToAdd.controls.length < maxHostnamesToAdd">
      <img class="add-more-img" src="assets/images/common/plus.svg" />
      <div class="add-endpoints-button-title">
        {{ 'policyPage.config.endpointFilteringContent.addMore' | labelsProvider }}
      </div>
    </div>
  </div>
  <div class="add-endpoints-footer">
    <button class="cancel" (click)="onClose()">
      {{ 'common.cancel' | labelsProvider }}
    </button>
    <button
      class="confirm"
      [ngClass]="{
        'confirm-disabled': addEndpointsFormGroup.invalid || waitingForResponse,
      }"
      (click)="addEndpoint()"
      cdkFocusInitial
    >
      <span *ngIf="!waitingForResponse">{{ 'common.add' | labelsProvider }}</span>
      <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </button>
  </div>
</div>
